export interface Musteri {
  id: number;
  adSoyad: string;
  telefon: string;
  eposta: string;
  adres: string;
  not: string;
  toplamAlacak: number;
  toplamSiparis: number;
  sonIslem: string;
}

export const musterilerData: Musteri[] = [
  {
    id: 1,
    adSoyad: "Ahmet Yılmaz",
    telefon: "+90 555 123 4567",
    eposta: "ahmet.yilmaz@email.com",
    adres: "Atatürk Cad. No:45, Fatih/İstanbul",
    not: "Düzenli müşteri, alyans ve düğün seti alıcısı.",
    toplamAlacak: 12500,
    toplamSiparis: 3,
    sonIslem: "2026-04-15",
  },
  {
    id: 2,
    adSoyad: "Fatma Kaya",
    telefon: "+90 555 234 5678",
    eposta: "fatma.kaya@email.com",
    adres: "İstiklal Cad. No:78, Beyoğlu/İstanbul",
    not: "Küpe ve bilezik koleksiyonu sever.",
    toplamAlacak: 8900,
    toplamSiparis: 2,
    sonIslem: "2026-04-20",
  },
  {
    id: 3,
    adSoyad: "Mehmet Demir",
    telefon: "+90 555 345 6789",
    eposta: "",
    adres: "Cumhuriyet Mah. 125. Sok. No:12, Üsküdar/İstanbul",
    not: "Kapıda ödeme tercih eder, hatırlatma gönder.",
    toplamAlacak: 15000,
    toplamSiparis: 5,
    sonIslem: "2026-04-28",
  },
  {
    id: 4,
    adSoyad: "Ayşe Çelik",
    telefon: "+90 555 456 7890",
    eposta: "ayse.celik@email.com",
    adres: "Bağdat Cad. No:234, Kadıköy/İstanbul",
    not: "Nişan ve söz takıları için sık gelir.",
    toplamAlacak: 6700,
    toplamSiparis: 2,
    sonIslem: "2026-05-01",
  },
  {
    id: 5,
    adSoyad: "Hasan Şahin",
    telefon: "+90 555 567 8901",
    eposta: "",
    adres: "Sakarya Cad. No:67, Eminönü/İstanbul",
    not: "Altın gram bazlı alışveriş yapar.",
    toplamAlacak: 21000,
    toplamSiparis: 4,
    sonIslem: "2026-04-30",
  },
  {
    id: 6,
    adSoyad: "Elif Arslan",
    telefon: "+90 555 678 9012",
    eposta: "elif.arslan@email.com",
    adres: "Mimar Sinan Mah. No:89, Ümraniye/İstanbul",
    not: "Yeni müşteri, hediye paketi isteyebilir.",
    toplamAlacak: 8000,
    toplamSiparis: 1,
    sonIslem: "2026-05-01",
  },
  {
    id: 7,
    adSoyad: "Kemal Öztürk",
    telefon: "+90 555 789 0123",
    eposta: "kemal.ozturk@email.com",
    adres: "Vatan Cad. No:112, Bayrampaşa/İstanbul",
    not: "VIP müşteri, özel tasarım siparişleri verir.",
    toplamAlacak: 0,
    toplamSiparis: 8,
    sonIslem: "2026-04-25",
  },
  {
    id: 8,
    adSoyad: "Sibel Yıldırım",
    telefon: "+90 555 890 1234",
    eposta: "",
    adres: "Güneşli Cad. No:34, Bağcılar/İstanbul",
    not: "Gümüş takıları tercih eder.",
    toplamAlacak: 8500,
    toplamSiparis: 3,
    sonIslem: "2026-04-18",
  },
  {
    id: 9,
    adSoyad: "Murat Aydın",
    telefon: "+90 555 901 2345",
    eposta: "murat.aydin@email.com",
    adres: "Yavuz Sultan Selim Cad. No:56, Gaziosmanpaşa/İstanbul",
    not: "Düğün seti tamamlandı, memnun müşteri.",
    toplamAlacak: 0,
    toplamSiparis: 6,
    sonIslem: "2026-04-22",
  },
  {
    id: 10,
    adSoyad: "Deniz Karaca",
    telefon: "+90 555 012 3456",
    eposta: "",
    adres: "Silivri Cad. No:23, Avcılar/İstanbul",
    not: "Yüzük boyutu düzeltme ve bakım işleri.",
    toplamAlacak: 9500,
    toplamSiparis: 2,
    sonIslem: "2026-04-29",
  },
  {
    id: 11,
    adSoyad: "Zeynep Koç",
    telefon: "+90 555 111 2222",
    eposta: "zeynep.koc@email.com",
    adres: "Taksim Meydanı No:1, Beyoğlu/İstanbul",
    not: "Doğum günü hediyeleri için sık uğrar.",
    toplamAlacak: 0,
    toplamSiparis: 4,
    sonIslem: "2026-04-10",
  },
  {
    id: 12,
    adSoyad: "Burak Yıldız",
    telefon: "+90 555 222 3333",
    eposta: "",
    adres: "Kartal Cad. No:89, Kartal/İstanbul",
    not: "Erkek takıları ve saat alıcısı.",
    toplamAlacak: 18000,
    toplamSiparis: 3,
    sonIslem: "2026-05-01",
  },
];